import format from 'date-fns/format';
import { isValid } from 'date-fns';
import { timing } from 'constants/ui.constants';
export interface Notification {
	companyId?: number;
	type: string;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date;
}

export const formatDate = (date: any) => {
	return isValid(new Date(date || ''))
		? format(
				new Date(date || ''),
				localStorage.getItem('language') === 'he' ? timing.FULLDATEHEBREW : timing.FULLDATE
		  )
		: date;
};

export enum NotificationType {
	Balance = 'Balance',
	Convert = 'Convert',
	Beneficiary = 'Beneficiary',
	Payment = 'Payment',
	Contact = 'Contact',
	BankAccount = 'BankAccount',
	SupportRequest = 'SupportRequest',
}
